import { render } from "./OrderStatusChart.vue?vue&type=template&id=390175be&scoped=true"
import script from "./OrderStatusChart.vue?vue&type=script&lang=js"
export * from "./OrderStatusChart.vue?vue&type=script&lang=js"

import "./OrderStatusChart.vue?vue&type=style&index=0&id=390175be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390175be"]])

export default __exports__